import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

class SuccessMessage extends Component {

    static propTypes = {
        link: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
    }

    render() {
        const { t, link } = this.props

        return (
            <div>{t('visualizer:toolbar.left.bookmark.create.success')}. <a href={link}>{t('visualizer:toolbar.left.bookmark.list')}</a></div>
        );
    }
}

export default withTranslation()(SuccessMessage)
